import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var SvgBedTwin = props => _jsxs("svg", _objectSpread(_objectSpread({
  width: 24,
  height: 24,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {}, {
  children: [_jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 5a1 1 0 0 1 1 1v4a2 2 0 0 1 2 2v5h-1.5l-.5 2H9l-.5-2h-5L3 19H2l-.5-2H0v-5a2 2 0 0 1 2-2V6a1 1 0 0 1 1-1h6Zm1 6H2a1 1 0 0 0-.993.883L1 12v4h10v-4a1 1 0 0 0-.883-.993L10 11ZM9 6H3v4h1V8a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2h1V6ZM7 8H5v2h2V8Z",
    fill: props.color || "#58595B"
  }), _jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 5a1 1 0 0 1 1 1v4a2 2 0 0 1 2 2v5h-1.5l-.5 2h-1l-.5-2h-5l-.5 2h-1l-.5-2H11v-5a2 2 0 0 1 2-2V6a1 1 0 0 1 1-1h6Zm1 6h-8a1 1 0 0 0-.993.883L12 12v4h10v-4a1 1 0 0 0-.883-.993L21 11Zm-1-5h-6v4h1V8a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2h1V6Zm-2 2h-2v2h2V8Z",
    fill: props.color || "#58595B"
  })]
}));
export default SvgBedTwin;